//@flow
import React from 'react';
import { Container } from 'flux/utils';
import NotificationsStore from '../../Stores/Notifications/notificationsStore';
import NotificationActions from '../../Actions/notifications';
import BaseNotification from './BaseNotification.react';

type State = {
  notificationData:?Object,
};

export type NotificationProps = {
  close:() => void,
  data:Object,
};

type Options<P> = {
  name:string,
  className:string,
  timeout?:number|(props:NotificationProps&P) => ?number,
  close?:(props:P) => void,
  shouldRender?:(props:NotificationProps&P) => boolean,
};

export default function standardNotification<P:{}>(
  NotificationContent:React$ComponentType<NotificationProps&P>,
  options:Options<P>):React$ComponentType<P> {

  class StandardNotification extends React.Component<P, State> {
    static WrappedComponent = NotificationContent;
    static displayName = `standardNotifiation(${NotificationContent.displayName || NotificationContent.name || ''})`;

    static getStores() {
      return [
        NotificationsStore,
      ];
    }

    static calculateState(prevState:State):State {
      return {
        notificationData: NotificationsStore.getNotification(options.name),
      };
    }

    _closeNotification = () => {
      NotificationActions.clearNotification(options.name);
      options.close && options.close(this.props);
    };

    _getTimeout(notificationProps):?number {
      if (typeof options.timeout === 'function') {
        return options.timeout(notificationProps);
      }

      return options.timeout;
    }

    render() {
      const data = this.state.notificationData;
      if (!data) return null;
      const addedNotificationProps = { close: this._closeNotification, data };
      const notificationProps = Object.assign({}, this.props, addedNotificationProps);
      if (notificationProps && options.shouldRender && !options.shouldRender(notificationProps)) return null;

      return (
        <BaseNotification
          className={options.className}
          closeNotification={this._closeNotification}
          data={data}
          name={options.name}
          timeout={this._getTimeout(notificationProps)}
        >
          <NotificationContent
            {...notificationProps}
          />
        </BaseNotification>
      );
    }
  }

  return Container.create(StandardNotification);
}
